import service from '@/service'

// 补货单列表

export function getList(data) {
  return service['api-scm']({
    url: '/replenishOrderSumController/getList',
    method: 'post',
    data
  })
}

// 指派
export function assignTask(data) {
  return service['api-scm']({
    url: '/replenishOrderSumController/assignTask',
    method: 'post',
    data
  })
}

// 日志
export function findOrderLog(data) {
  return service['api-scm']({
    url: '/replenishOrderSumController/findOrderLog',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 查询库存
export function inventoryDetailList(data) {
  return service['api-scm']({
    url: '/replenishOrderSumController/inventoryDetailList',
    method: 'post',
    data
  })
}

// 重新匹配供应商
export function rematchSupplier(data) {
  return service['api-scm']({
    url: '/replenishOrderController/rematchSupplier',
    method: 'post',
    data
  })
}

// 导出
export function exportList(data) {
  return service['api-scm']({
    url: '/replenishOrderSumController/exportList',
    method: 'post',
    data
  })
}

// 关闭补货单
export function closeOrder(data) {
  return service['api-scm']({
    url: '/replenishOrderSumController/closeOrder',
    method: 'post',
    data
  })
}

// 聚合查询
export function aggregateQuery(data) {
  return service['api-scm']({
    url: '/replenishOrderSumController/aggregateQuery',
    method: 'post',
    data
  })
}

// 采购任务统计
export function findPurchaseTaskSumList(data) {
  return service['api-scm']({
    url: '/replenishOrderController/findPurchaseTaskSumList',
    method: 'post',
    data
  })
}

// 采购任务统计导出
export function exportPurchaseTaskSumData(data) {
  return service['api-scm']({
    url: '/replenishOrderController/exportPurchaseTaskSumData',
    method: 'post',
    data,
    responseType: 'blob', // 文件流接收类型声明转成 blob
    saveAs: false // 文件流是否通过浏览器下载
  })
}
